import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("inputMaskHelper")
export class inputMaskHelper {
    static maskWtpOld = "WAAAAAAA-AAA-AAA";
    static maskWtpNew = "ZSAA-AAAA-AAAA-AAAA";
    static maskMediaID = "NNNN-NNNN-NNNN-NNNN-NNNN";

    private static projNr: number = 0;
    private static birthdayPattern: string;

    static init(birthdayPattern: string, projNr: number) {
        this.birthdayPattern = birthdayPattern;
        this.projNr = projNr;
        const i18nHelper = new I18nHelper();


        //@ts-ignore
        jQuery.validator.addMethod("wtpNumber", function (value, element) {
            const isComplete = $(element).inputmask("isComplete");
            return isComplete;

        }, i18nHelper.GetTranslation(Translations.WTPNumberNotFound));
    }

    static setBirthdayPattern(birthdayPattern) {
        this.birthdayPattern = birthdayPattern;
    }

    static getBirthdayPattern() {
        return this.birthdayPattern;
    }

    static wtpNumberMask() {
        const patternList: string[] = [this.maskWtpOld, this.maskMediaID, this.maskWtpNew];

        if (this.projNr.toString().length === 4) {
            return [...patternList].reverse();
        }

        return patternList;
    }

    static openpassMaskOptions(): Inputmask.Options {
        return {
            removeMaskOnSubmit: false,
            placeholder: "_",
            definitions: {
                "A": {
                    validator: "[1-9A-Za-z]",
                    casing: "upper"
                }
            }
        }
    }

    static wtpMaskOptions(): Inputmask.Options {
        return {
            removeMaskOnSubmit: false,
            placeholder: "_",
            definitions: {
                "Z": {
                    validator: "[Zz]",
                    casing: "upper"
                },
                "S": {
                    validator: "[1-9A-Za-z]",
                    casing: "upper"
                },
                "W": {
                    validator: "[A-Fa-fGHJKLMNPghjklmnp]",
                    casing: "upper"
                },
                "A": {
                    //BIOV not allowed
                    validator: "[0-9ACDEFGHJKLMNPQRSTUWXYZacdefghjklmnpqrstuwxyz]",
                    casing: "upper"
                },
                "X": {
                    validator: "[0-9A-Za-z\-]",
                    casing: "upper"
                },
                "N": {
                    validator: "[0-9]",
                    casing: "upper"
                }
            }
        };
    }
}